<template>
  <el-select :disabled="disabled" filterable :clearable='clearable' @change="handleChange" :value="data" placeholder="请选择"
           :multiple='multiple'  @clear="handleChange">
    <el-option :label="item.name" :value="item.value" v-for="(item,index) in deviceType" :key="index"></el-option>
  </el-select>
</template>

<script>
    // import { findTypeList } from "@/services/deviceOrder";
     import { EditionfindPage } from "@/services/product";

    export default {
        name: 'MultipleType',
        props: {
            value: {},
            type:{
                type:Number,
                default:2
            },
            brandId:{
                type: Object,
                default: () => ({})
            },
            modelId:{
                type: Object,
                default: () => ({})
            },
            disabled: {
                type: Boolean,
                default: false
            },
            clearable:{
                type: Boolean,
                default: true
            },
            multiple: {
                type: Boolean,
                default: true,
            },
        },

        data() {
            return {data: [], deviceType: []}
        },
        watch: {
            value:{
                immediate: true,
                handler(value) {
                    // console.log(value,"777899///")
                    this.data=[...value];
                }
            },
             modelId:{
                immediate:true,
                handler(modelId){
                    this.deviceType=[]
                    if(modelId.value){
                        // console.log("774",modelId)
                         this.loadData();
                    }
                   
                }
            },
           
        },
        mounted() {
            // this.loadData();
        },
        methods: {
           
            handleChange(value) {
                

                
                this.data=value;
                // console.log(value,"7878")
               let arr= this.deviceType.filter((item)=>{
                    return value.includes(item.value)
                })
                
                    
                let name=[]
                arr.forEach((item)=>{
                         name.push(item.name)
                })
                this.$emit("input",value);
                this.$emit("change", {name:name})


            },
            async loadData() {
               this.deviceType =[]
            //    this.data = [];
               let searchData={
                    brandId:this.brandId.value?this.brandId.value:'',
                    modelId:this.modelId.value?this.modelId.value:""
                }
                if(searchData.brandId&&searchData.modelId){
                        const response = await EditionfindPage({
                            page: 1,
                            size: 999,
                            type:this.type,
                            ...searchData
                        });
              
                        if (response&&response.code==0) {
                            this.deviceType = response.data.list.map((item, i) => {
                                return {name: item.editionName, value: item.id}
                            })
                        }
                }
                // console.log(this.deviceType,'8599')
              
            }

        }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/operation/deviceHasMultipl.vue